'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dRequest from "./presto.-Agent-View$-Local-Pje-Office-Sign-File-Request.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$() {
}
export { $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$ as $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$ };
$p = $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$;
/** @constructor */
function $h_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$() {
}
export { $h_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$ as $h_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$ };
$h_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$.prototype = $p;
$p.l = (function() {
  return "LocalPjeOfficeSignFileRequest";
});
$p.cGQ = (function(x$0) {
  return new $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dRequest.$c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest(x$0.j(0), x$0.j(1), x$0.j(2), (!(!x$0.j(3))), x$0.j(4));
});
var $d_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$, "presto.AgentView$LocalPjeOfficeSignFileRequest$", ({
  Eo: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$ as $d_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$ };
var $n_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$;
function $m_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$() {
  if ((!$n_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$)) {
    $n_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$ = new $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$();
  }
  return $n_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$;
}
export { $m_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$ as $m_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$ };
//# sourceMappingURL=presto.-Agent-View$-Local-Pje-Office-Sign-File-Request$.js.map
